import { createSlice } from "@reduxjs/toolkit";

const initialState: IHomeState = {
  infraCountData: null,
  sgName: "",
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
};

export const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceInfraCountData: (state, action) => {
      const { countData } = action.payload;
      state.infraCountData = countData;
    },
    replaceSGNameData: (state, action) => {
      const { sgNames } = action.payload;
      state.sgName = sgNames;
    },
  },
});

export const homeActions = homeSlice.actions;
export default homeSlice.reducer;
